const LoadingSpinner = ({ size = 'md', text = 'Chargement...' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16'
  };

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className={`loading-spinner ${sizeClasses[size]} mb-4`} />
      <p className="font-secondary text-sm text-muted-foreground">{text}</p>
    </div>
  );
};

export default LoadingSpinner;